import { render, staticRenderFns } from "./Advertising2Slots.vue?vue&type=template&id=64d149df&scoped=true"
import script from "./Advertising2Slots.vue?vue&type=script&lang=js"
export * from "./Advertising2Slots.vue?vue&type=script&lang=js"
import style0 from "./Advertising2Slots.vue?vue&type=style&index=0&id=64d149df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d149df",
  null
  
)

export default component.exports